import React from "react";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import { storyReportReasons } from "../../utils/constants";
import { reportStorySchema } from "../../utils/validationSchemas";
import { successMsg } from "../../utils/toastMessage";
import { handleApiRequest } from "../../services/handleApiRequest";
import { reportStory } from "../../redux/stories/thunk";
import MySelect from "../common/mySelect";
import { ErrorField } from "../common/errorField";

export default function ReportStoryPop({ userAction, setUserAction }) {
  const handleClose = () => {
    setUserAction(null);
  };

  const handleReport = async () => {
    const request = { ...values, storyId: userAction.id };
    const response = await handleApiRequest(reportStory, request, true, (error) => {
      if (error?.statusCode === 403) {
        successMsg(error?.message);
      }
    });

    if (response.status) {
      successMsg("Thanks for your feedback!!");
      handleClose();
    }
  };

  const { values, errors, handleChange, handleSubmit, setFieldValue } = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: { reason: "", description: "" },
    validationSchema: reportStorySchema,
    onSubmit: handleReport,
  });

  return (
    <Modal
      show={!!userAction}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
      className="reportStoryPop"
    >
      <Modal.Header closeButton>
        <h5 className="m-0">Report Story</h5>
      </Modal.Header>
      <Modal.Body>
        <div>
          <h6 className="text-center m-0">
            Let us know
            <br />
            What's wrong in this post?
          </h6>

          <div className="my-4">
            <div>
              <label className="mb-1">Reason</label>
              <MySelect
                className="my-1"
                options={storyReportReasons || []}
                value={
                  values.reason
                    ? storyReportReasons.find((item) => item.value === values.reason)
                    : ""
                }
                onChange={(selected) => {
                  setFieldValue("reason", selected);
                }}
              />
              <ErrorField error={errors.reason} />
            </div>

            <div className="mt-2">
              <label className="">Description</label>
              <textarea
                className=" height-100 form-control shadow-none my-1"
                placeholder="Please describe what's wrong in this story"
                name="description"
                value={values.description}
                onChange={handleChange}
              />
              <div className="d-flex align-items-center justify-content-between">
                <span>
                  <ErrorField error={errors.description} />
                </span>
                <p className="small m-0 text-end text-light-emphasis">
                  {values.description?.length}/500
                </p>
              </div>
            </div>
          </div>

          <div className="btn-wrap my-2 d-flex align-items-center justify-content-end mt-3 gap-10">
            <button
              onClick={handleClose}
              className="outlineBtn border border-secondary rounded px-3 py-1"
            >
              Back
            </button>
            <button onClick={handleSubmit} className="primaryBtn rounded px-3 py-1">
              Submit
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
